/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from "../ApiClient";
import CreateCustomerTankRequest from '../model/CreateCustomerTankRequest';
import CreateCustomerTankResponse from '../model/CreateCustomerTankResponse';
import DeleteCustomerTankResponse from '../model/DeleteCustomerTankResponse';
import ErrorResponse from '../model/ErrorResponse';
import GetCustomerTankResponse from '../model/GetCustomerTankResponse';
import ReplaceSensorRequest from '../model/ReplaceSensorRequest';
import ReplaceSensorResponse from '../model/ReplaceSensorResponse';
import SearchCustomerTankResponse from '../model/SearchCustomerTankResponse';
import SearchTanksResponse from '../model/SearchTanksResponse';
import UpdateCustomerTankRequest from '../model/UpdateCustomerTankRequest';
import UpdateCustomerTankResponse from '../model/UpdateCustomerTankResponse';

/**
* Tanks service.
* @module api/TanksApi
* @version 2020-12-7
*/
export default class TanksApi {

    /**
    * Constructs a new TanksApi. 
    * @alias module:api/TanksApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * タンクを登録する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CreateCustomerTankResponse} and HTTP response
     */
    createCustomerTankWithHttpInfo(body, customerId) {
      let postBody = body;

      let pathParams = {
        'customerId': customerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = CreateCustomerTankResponse;

      return this.apiClient.callApi(
        '/customers/{customerId}/tanks', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * タンクを登録する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CreateCustomerTankResponse}
     */
    createCustomerTank(body, customerId) {
      return this.createCustomerTankWithHttpInfo(body, customerId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    customersIdTankIdPreflightWithHttpInfo(customerId, tankId) {
      let postBody = null;

      let pathParams = {
        'customerId': customerId,
        'tankId': tankId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/customers/{customerId}/tanks/{tankId}', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    customersIdTankIdPreflight(customerId, tankId) {
      return this.customersIdTankIdPreflightWithHttpInfo(customerId, tankId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * preflight
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    customersIdTankIdReplaceSensorPreflightWithHttpInfo(customerId, tankId, opts) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
        'customerId': customerId,
        'tankId': tankId
      };
      let queryParams = {
        'dryrun': opts['dryrun']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/customers/{customerId}/tanks/{tankId}/replace-sensor', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    customersIdTankIdReplaceSensorPreflight(customerId, tankId, opts) {
      return this.customersIdTankIdReplaceSensorPreflightWithHttpInfo(customerId, tankId, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    customersIdTankPreflightWithHttpInfo(customerId) {
      let postBody = null;

      let pathParams = {
        'customerId': customerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/customers/{customerId}/tanks', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    customersIdTankPreflight(customerId) {
      return this.customersIdTankPreflightWithHttpInfo(customerId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * タンクを削除する。
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DeleteCustomerTankResponse} and HTTP response
     */
    deleteCustomerTankWithHttpInfo(customerId, tankId) {
      let postBody = null;

      let pathParams = {
        'customerId': customerId,
        'tankId': tankId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = DeleteCustomerTankResponse;

      return this.apiClient.callApi(
        '/customers/{customerId}/tanks/{tankId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * タンクを削除する。
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DeleteCustomerTankResponse}
     */
    deleteCustomerTank(customerId, tankId) {
      return this.deleteCustomerTankWithHttpInfo(customerId, tankId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * タンクを1件取得する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetCustomerTankResponse} and HTTP response
     */
    getCustomerTankWithHttpInfo(customerId, tankId, opts) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
        'customerId': customerId,
        'tankId': tankId
      };
      let queryParams = {
        'rangeFrom': opts['rangeFrom'],
        'rangeTo': opts['rangeTo']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GetCustomerTankResponse;

      return this.apiClient.callApi(
        '/customers/{customerId}/tanks/{tankId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * タンクを1件取得する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetCustomerTankResponse}
     */
    getCustomerTank(customerId, tankId, opts) {
      return this.getCustomerTankWithHttpInfo(customerId, tankId, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * タンクのセンサーを交換する 
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ReplaceSensorResponse} and HTTP response
     */
    replaceSensorWithHttpInfo(body, customerId, tankId, opts) {
      opts = opts || {};
      let postBody = body;

      let pathParams = {
        'customerId': customerId,
        'tankId': tankId
      };
      let queryParams = {
        'dryrun': opts['dryrun']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ReplaceSensorResponse;

      return this.apiClient.callApi(
        '/customers/{customerId}/tanks/{tankId}/replace-sensor', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * タンクのセンサーを交換する 
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ReplaceSensorResponse}
     */
    replaceSensor(body, customerId, tankId, opts) {
      return this.replaceSensorWithHttpInfo(body, customerId, tankId, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * 指定した顧客のタンクを全件取得する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SearchCustomerTankResponse} and HTTP response
     */
    searchCustomerTanksWithHttpInfo(customerId) {
      let postBody = null;

      let pathParams = {
        'customerId': customerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = SearchCustomerTankResponse;

      return this.apiClient.callApi(
        '/customers/{customerId}/tanks', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 指定した顧客のタンクを全件取得する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SearchCustomerTankResponse}
     */
    searchCustomerTanks(customerId) {
      return this.searchCustomerTanksWithHttpInfo(customerId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * タンクを取得する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SearchTanksResponse} and HTTP response
     */
    searchTanksWithHttpInfo(opts) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'groupId': opts['groupId'],
        '_with': opts['_with']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = SearchTanksResponse;

      return this.apiClient.callApi(
        '/tanks', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * タンクを取得する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SearchTanksResponse}
     */
    searchTanks(opts) {
      return this.searchTanksWithHttpInfo(opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    tanksPreflightWithHttpInfo() {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/tanks', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    tanksPreflight() {
      return this.tanksPreflightWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * タンクを更新する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UpdateCustomerTankResponse} and HTTP response
     */
    updateCustomerTankWithHttpInfo(body, customerId, tankId) {
      let postBody = body;

      let pathParams = {
        'customerId': customerId,
        'tankId': tankId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = UpdateCustomerTankResponse;

      return this.apiClient.callApi(
        '/customers/{customerId}/tanks/{tankId}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * タンクを更新する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UpdateCustomerTankResponse}
     */
    updateCustomerTank(body, customerId, tankId) {
      return this.updateCustomerTankWithHttpInfo(body, customerId, tankId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }

}
